import pageMetadataBuilder from '@spotahome/ui-library/src/utils/metadata';
import {
  getPageTitleForRentableUnit,
  getPageDescriptionForRentableUnit
} from '@spotahome/marketplace-common/src/utils/page-title-builder';

import { getJsonLdApartmentComplex } from '../utils/getJsonLdApartmentComplex';
import { getJsonLdHowToBook } from '../utils/getJsonLdHowToBook';

export const getHeadersEmptyResponse = () => ({
  metas: [],
  title: 'Listing not found'
});

const getPreloadImageLink = imageUrl => {
  if (!imageUrl) return null;

  return {
    rel: 'preload',
    as: 'image',
    href: imageUrl.replace('.jpg', '.webp')
  };
};

export const buildHeadersData = ({
  rentableUnitData,
  cityName,
  clientConfig,
  city,
  req,
  dataLayerScript,
  imagesToBePreloaded
}) => {
  const { locale, trans } = req;
  const { seo } = rentableUnitData;
  const facebookMetadata = { appId: clientConfig.FB_APP_ID };
  const msMetadata = { validate: clientConfig.MSVALIDATE };

  const title = getPageTitleForRentableUnit(
    rentableUnitData,
    locale,
    city,
    cityName
  );

  const description = getPageDescriptionForRentableUnit(
    rentableUnitData,
    locale,
    city,
    cityName
  );

  const metas = pageMetadataBuilder({
    ...seo,
    basic: {
      ...seo.basic,
      title,
      description
    },
    fb: facebookMetadata,
    ms: msMetadata,
    city,
    cityName
  });

  const innerHTMLs = [dataLayerScript].map(html => ({
    innerHTML: html
  }));

  const scripts = [
    ...innerHTMLs,
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify(
        getJsonLdApartmentComplex(
          rentableUnitData.listing,
          rentableUnitData.seo,
          getPageTitleForRentableUnit(
            rentableUnitData,
            locale,
            city,
            cityName,
            false
          )
        )
      )
    }
  ];

  scripts.push({
    type: 'application/ld+json',
    innerHTML: JSON.stringify(getJsonLdHowToBook(trans))
  });

  return {
    title,
    metas,
    scripts,
    links: [...imagesToBePreloaded.map(getPreloadImageLink)].filter(Boolean)
  };
};

export default { buildHeadersData, getHeadersEmptyResponse };
